import { Component, OnInit } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {
  type;
  private categorie='sante';
  private videos;
  private index=0;
  private timeOut;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.getVideoType();
    this.setVideos();
    this.startTimeOut();
  }

  getVideoType(): void {
    this.type = this.route.snapshot.paramMap.get('type');
    console.log("getVideoType ", this.type);
  }

  setVideos(): void {
    switch(this.type) {
      case 'vidéos':
        this.videos=[
          {img:"videos/egalite.jpg", video:"videos/egalite.mp4", titre:"Egalité Femmes-Hommes"},
          {img:"videos/diesel.jpg", video:"videos/plan-diesel.mp4", titre:"Le Plan Diesel"},
          {img:"videos/fusion.jpg", video:"videos/projet-fusion-alstom-siemens.mp4", titre:"Projet de fusion Alstom-Siemens"},
          {img:"videos/digitalisation.jpg", video:"videos/digitalisation.mp4", titre:"Digitalisation et emploi dans le secteur de la santé"},
          {img:"videos/expertise.jpg", video:"videos/expertise.mp4", titre:"Expertise sur la Créosote"},
          {img:"videos/reforme.jpg", video:"videos/reforme-fonction-publique.mp4", titre:"Réforme de la fonction Publique"},
          {img:"videos/enjeux.jpg", video:"videos/les-enjeux-ecologiques.mp4", titre:"Les enjeux écologiques"},
          {img:"videos/industrie.jpg", video:"videos/industrie-du-futur.mp4", titre:"L’industrie du futur & l’intelligence artificielle"},
          {img:"videos/missionSTX.jpg", video:"videos/mission-stx.mp4", titre:"Mission STX"},
        ];
        break;
      case 'youtube':
        this.videos={sante: [
          {img:"youtube/sante/CSSCT.jpg", video:"youtube/sante/la-cssct.mp4", titre:"La CSSCT"},
          {img:"youtube/sante/moyens.jpg", video:"youtube/sante/les-moyens-de-la-cssct.mp4", titre:"Les moyens de la CSSCT"},
          {img:"youtube/sante/accident.jpg", video:"youtube/sante/comment-reagir-lors-d-un-AT.mp4", titre:"Comment réagir lors d'un AT ?"},
          {img:"youtube/sante/reunion.jpg", video:"youtube/sante/la-reunion-extraordinaire.mp4", titre:"La réunion extraordinaire"},
          {img:"youtube/sante/papripact.jpg", video:"youtube/sante/papripact.mp4", titre:"Le PAPRIPACT"},
        ],
          economique: [
            {img:"youtube/economique/protocole.jpg", video:"youtube/economique/protocole-pre-electoral.mp4", titre:"Pensez à négocier le fonctionnement du CSE en amont du protocole d'accord préélectoral !"},
            {img:"youtube/economique/avis.jpg", video:"youtube/economique/avis-du-cse.mp4", titre:"L'avis du CSE"},
            {img:"youtube/economique/interessement.jpg", video:"youtube/economique/accord-interessement.mp4", titre:"Bien négocier un accord l’intéressement"},
            {img:"youtube/economique/consultation.jpg", video:"youtube/economique/consultation-situation-financiere.mp4", titre:"Maîtriser la consultation sur la situation économique et financière de son entreprise"},
            {img:"youtube/economique/ordre.jpg", video:"youtube/economique/ordre-du-Jour-cse.mp4", titre:"L’ordre du jour du CSE"},
          ]};
        break;
      case 'tutos':
        this.videos=[
          {img:"tutos/cse.jpg", video:"tutos/cse.mp4", titre:"Le Comité social et économique"},
          {img:"tutos/negociation.jpg", video:"tutos/negociation.mp4", titre:"La négociation collective"},
          {img:"tutos/rupture.jpg", video:"tutos/rupture.mp4", titre:"La rupture conventionnelle collective"},
          {img:"tutos/reforme.jpg", video:"tutos/reforme.mp4", titre:"La réforme de la formation professionnelle 2018"},
        ];
        break;
      case 'go animate':
        this.videos=[
          {img:"goanimate/rgpd.jpg", video:"goanimate/rgpd.mp4", titre:"RGPD"},
          {img:"goanimate/europe.jpg", video:"goanimate/europe.mp4", titre:"EUROPE"},
          {img:"goanimate/th-conseil.jpg", video:"goanimate/th-conseil.mp4", titre:"TH CONSEIL"}
        ];
        break;
    }
  }

  goHome() {
    clearTimeout(this.timeOut); // nécessaire car angular ne détruit pas le timeOut lorsque l'on navigue par le router
    this.router.navigate(["home"]);
  }

  download(type) {
    clearTimeout(this.timeOut); // nécessaire car angular ne détruit pas le timeOut lorsque l'on navigue par le router
    this.router.navigate(['contact/'+type]);
  }

  show(index, categorie) {
    this.index = index;
    if (categorie!=undefined) {this.categorie = categorie};
    this.startTimeOut();
  }

  startTimeOut(){
    console.log('startTimeOut');
    clearTimeout(this.timeOut);
    this.timeOut = setTimeout(()=>{
      this.router.navigate(['home']);
    }, 300000);
  }

}
